import React from "react";

export interface GPUHoursBalanceProps {
  balanceRange: string;
}
const GPUHoursBalance: React.FC<GPUHoursBalanceProps> = ({ balanceRange }) => {
  return <span>{balanceRange}</span>;
};

export default GPUHoursBalance;
